import isDevelopment from './isDevelopment'

export default !isDevelopment && (
  process.env.NODE_ENV === 'development'
  || window.location.hostname.indexOf('staging.infowijs.nl') > -1
  || window.location.hostname.indexOf('testschool.hoyapp.nl') > -1
  || window.location.hostname.indexOf('testschool2.hoyapp.nl') > -1
  || window.location.hostname.indexOf('usertestschool.hoyapp.nl') > -1
  || window.location.hostname.indexOf('staging.hoyapp.nl') > -1
)
